const MODULE_NAME = 'WorkInstructionModule';

export const GET_WORK_INSTRUCTION_PACKAGES = `${MODULE_NAME}/GET_WORK_INSTRUCTION_PACKAGES`;
export const CURRENT_WORK_INSTRUCTION_PACKAGE = `${MODULE_NAME}/CURRENT_WORK_INSTRUCTION_PACKAGE`;
export const GET_WORK_INSTRUCTION = `${MODULE_NAME}/GET_WORK_INSTRUCTION`;
export const JOB_HAS_WORK_INSTRUCTIONS = `${MODULE_NAME}/JOB_HAS_WORK_INSTRUCTIONS`;
export const JOB_WORK_INSTRUCTION_COUNT = `${MODULE_NAME}/JOB_WORK_INSTRUCTION_COUNT`;
export const JOB_WORK_INSTRUCTION_STATUS_LOADING = `${MODULE_NAME}/JOB_WORK_INSTRUCTION_STATUS_LOADING`;
export const JOB_WORK_INSTRUCTION_STATUS_LOADED = `${MODULE_NAME}/JOB_WORK_INSTRUCTION_STATUS_LOADED`;
